import { EventCard } from '@/components/events/EventCard';
import { AppShell } from '@/components/layout/AppShell';
import { DataStatePanel } from '@/components/shared/DataStatePanel';
import { EmptyState } from '@/components/shared/EmptyState';
import { PageHeader } from '@/components/shared/PageHeader';
import { useGuildData } from '@/hooks/useGuildData';

export function CurrentMassesPage(): JSX.Element {
  const { currentMasses, isLoading, error, refreshData } = useGuildData();

  return (
    <AppShell>
      <PageHeader
        title="Current Masses"
        description="Current and upcoming masses."
      />

      <div className="stack">
        {isLoading ? (
          <DataStatePanel title="Loading masses" description="Fetching current and upcoming events from Supabase." />
        ) : error ? (
          <DataStatePanel title="Unable to load masses" description={error} actionLabel="Retry" onAction={() => void refreshData()} />
        ) : currentMasses.length > 0 ? (
          currentMasses.map((event) => <EventCard key={event.id} event={event} />)
        ) : (
          <EmptyState title="No masses scheduled" description="When officers create the next mass, it will show up here." />
        )}
      </div>
    </AppShell>
  );
}
